import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import About from "../components/About";
import Services from "../components/Services";
import Stats from "../components/Stats";
import Projects from "../components/Projects";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Blog from "../components/Blog";
import CTA from "../components/CTA";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Features />
      <About />
      <Services />
      <Stats />
      <Projects />
      <Clients />
      <Testimonials />
      <FAQ />
      <Blog />
      <CTA />
      <Contact />
      <Footer />
    </main>
  );
}
